import {createAction, props} from "@ngrx/store";
import {CaseEntityDto} from "@esa/api/models/CaseEntityDto";
import {
  CreateCaseEntityWithCategory,
  UpdateCaseEntityWithCategory
} from "../../models/case-category";

export const getCaseEntities = createAction(
  '[Case Entities] Get Case Entities',
)
export const getCaseEntitiesSuccess = createAction(
  '[Case Entities] Get Case Entities Success',
  props<{ caseEntities: CaseEntityDto[] }>()
)
export const getCaseEntitiesError = createAction(
  '[Case Entities] Get Case Entities Error',
)

export const getCaseEntityById = createAction(
  '[Case Entities] Get Case Entity By ID',
  props<{ id: string }>()
)
export const getCaseEntityByIdSuccess = createAction(
  '[Case Entities] Get Case Entity By ID Success',
  props<{ selectedCaseEntity: CaseEntityDto }>()
)
export const getCaseEntityByIdError = createAction(
  '[Case Entities] Get Case Entity By ID Error',
)

export const createCaseEntity = createAction(
  '[Case Entities] Create Case Entity',
  props<{ caseEntity: CreateCaseEntityWithCategory }>()
)
export const createCaseEntitySuccess = createAction(
  '[Case Entities] Create Case Entity Success',
  props<{ showEditForm: boolean }>()
)
export const createCaseEntityError = createAction(
  '[Case Entities] Create Case Entity Error',
)

export const updateCaseEntity = createAction(
  '[Case Entities] Update Case Entity',
  props<{ caseEntity: UpdateCaseEntityWithCategory }>()
)
export const updateCaseEntitySuccess = createAction(
  '[Case Entities] Update Case Entity Success'
)
export const updateCaseEntityError = createAction(
  '[Case Entities] Update Case Entity Error',
)

export const setSelectedCaseEntityId = createAction(
  '[Case Entities] Set Selected Case Entity Id',
  props<{ selectedCaseEntityId: string }>()
)

export const setShowEditForm = createAction(
  '[Case Entities] Set edit form state',
  props<{ showEditForm: boolean }>()
)
